/* ZCT_V22_START (E2): Startseite, Verhalten wie Home und ZenRoom in v21.
   - zct-hero (JS-015): Video beim Start abspielen; scheitert das (z. B. Stromsparmodus), erscheint der Play-Knopf
     .hero-play-btn direkt nach dem Video. Am Ende von vorn, bei stalled/waiting nach 1 s erneut, beim Zurückkehren
     in den Tab erneut. Klick auf den Knopf spielt ab und entfernt ihn.
   - zct-zenraum (JS-017): Hover und Fokus auf Pin oder Karte setzen active, dim, visible und has-active wie in v21. */
(function () {
  'use strict';

  class ZctHero extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('video.hero-bg');
      if (!v) return;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var knopf = null;
      function zeigeKnopf() {
        if (knopf) return;
        knopf = document.createElement('button');
        knopf.className = 'hero-play-btn';
        knopf.setAttribute('aria-label', (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'Play video' : 'Video abspielen'); // E7: je Sprache
        knopf.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="23" stroke="rgba(255,255,255,0.6)" stroke-width="1.5"></circle><polygon points="19,15 35,24 19,33" fill="#fff"></polygon></svg>';
        knopf.addEventListener('click', function () {
          v.dataset.zctGestartet = '1';
          v.play().then(function () { if (knopf) { knopf.remove(); knopf = null; } }).catch(function () {});
        });
        v.after(knopf);
      }
      // Paket D (J11): bei „Bewegung reduzieren“ kein automatisches Abspielen, Standbild mit Abspiel-Knopf
      var ruhig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      function versuch() { if (ruhig && !v.dataset.zctGestartet) { v.pause(); zeigeKnopf(); return; } var p = v.play(); if (p && p.catch) p.catch(zeigeKnopf); }
      v.muted = true;
      if (ruhig) { v.removeAttribute('autoplay'); v.pause(); }
      versuch();
      v.addEventListener('ended', function () { v.currentTime = 0; versuch(); }, s);
      var haenger = function () { setTimeout(function () { if (v.paused) versuch(); }, 1000); };
      v.addEventListener('stalled', haenger, s);
      v.addEventListener('waiting', haenger, s);
      document.addEventListener('visibilitychange', function () { if (!document.hidden && v.paused) versuch(); }, s);
    }
    disconnectedCallback() { if (this.ab) this.ab.abort(); }
  }

  class ZctZenraum extends HTMLElement {
    connectedCallback() {
      var stage = this.querySelector('.stage');
      if (!stage) return;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var pins = Array.prototype.slice.call(this.querySelectorAll('a.pin'));
      var karten = Array.prototype.slice.call(this.querySelectorAll('a.pin-card'));
      var aktiv = null;
      function zeichnen() {
        var sk = 'stage ' + (aktiv ? 'has-active' : '');
        if (stage.className !== sk) stage.className = sk;
        pins.forEach(function (p) {
          var id = p.getAttribute('data-zct-pin');
          var dir = (p.className.match(/dir-[\w-]+/) || ['dir-left'])[0];
          var k = 'pin ' + dir + ' ' + (aktiv === id ? 'active' : '') + ' ' + (aktiv && aktiv !== id ? 'dim' : '');
          if (p.className !== k) p.className = k;
        });
        karten.forEach(function (c) {
          var id = c.getAttribute('data-zct-pin');
          var dir = (c.className.match(/dir-[\w-]+/) || ['dir-left'])[0];
          var k = 'pin-card ' + dir + ' ' + (aktiv === id ? 'visible' : '');
          if (c.className !== k) c.className = k;
        });
      }
      function setze(id) { aktiv = id; zeichnen(); }
      pins.forEach(function (p) {
        var id = p.getAttribute('data-zct-pin');
        p.addEventListener('mouseenter', function () { setze(id); }, s);
        p.addEventListener('mouseleave', function () { setze(null); }, s);
        p.addEventListener('focus', function () { setze(id); }, s);
        p.addEventListener('blur', function () { setze(null); }, s);
      });
      karten.forEach(function (c) {
        var id = c.getAttribute('data-zct-pin');
        c.addEventListener('mouseenter', function () { setze(id); }, s);
        c.addEventListener('mouseleave', function () { setze(null); }, s);
      });
    }
    disconnectedCallback() { if (this.ab) this.ab.abort(); }
  }

  if (!customElements.get('zct-hero')) customElements.define('zct-hero', ZctHero);
  if (!customElements.get('zct-zenraum')) customElements.define('zct-zenraum', ZctZenraum);
})();
